import { render, staticRenderFns } from "./IconCross.vue?vue&type=template&id=e5043930&scoped=true&"
var script = {}
import style0 from "./IconCross.vue?vue&type=style&index=0&id=e5043930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5043930",
  null
  
)

export default component.exports